<template>
    <div id="bio-container">
        <div class="container">
            <h1>
                {{ $t('biographyPage.biography') }}
                <hr>
            </h1>
            <div id="biography">
                <div id="photo-div">
                    <img src="../assets/images/Serdar-Kaynak-Bio.webp" alt="">
                </div>
                
                <div id="text-div">
                    <p class="multiline"> {{ biographyInfoFiltered.biography }}</p>
                </div>
            </div>
        </div>
        
        <div id="achievements">
            <h1>
                {{ $t('biographyPage.achievements') }}
                <hr>
            </h1>
            <div id="achievement-child-container">
                <div id="solo-exhibitions" class="achievement-child">
                    <h3>{{ $t('biographyPage.personalExhibitions') }}:</h3>
                    <ul v-for="personalExhibition in achievementsInfoFiltered.personalExhibitions" :key="personalExhibition.text">
                        <li><span>{{ personalExhibition.year }}</span> {{ personalExhibition.text }} </li>
                    </ul>
                </div>
                <div id="group-exhibitions" class="achievement-child">
                    <h3>{{ $t('biographyPage.selectedGroupExhibitions') }}:</h3>
                    
                    <ul v-for="groupExhibition in achievementsInfoFiltered.selectedGroupExhibitions" :key="groupExhibition.text">
                        <li><span>{{ groupExhibition.year }}</span> {{ groupExhibition.text }} </li>
                    </ul>
                </div>
                <div id="symposiums" class="achievement-child">
                    <h3>{{ $t('biographyPage.symposiums') }}: </h3>

                    <ul v-for="symposium in achievementsInfoFiltered.symposiums" :key="symposium.text">
                        <li><span>{{ symposium.year }}</span> {{ symposium.text }} </li>
                    </ul>
                </div>
                <div id="art-fairs" class="achievement-child">
                    <h3>{{ $t('biographyPage.artFairs') }}: </h3>
                   
                    <ul v-for="fair in achievementsInfoFiltered.fairs" :key="fair.text">
                        <li><span> {{ fair.year }}</span> {{ fair.text }} </li>
                    </ul>
                </div>
                <div id="awards" class="achievement-child">
                    <h3>{{ $t('biographyPage.awards') }}: </h3>
                    
                    <ul v-for="prize in achievementsInfoFiltered.prizes" :key="prize.text">
                        <li><span> {{ prize.year }} </span> {{ prize.text }} </li>
                    </ul>
                </div>
                <div id="sculpture-locations" class="achievement-child">
                    <h3>{{ $t('biographyPage.locationOfTheArtworks') }}: </h3>
                    <ul>
                        <li>{{ $t('biographyPage.locationOfTheArtworksDesc') }}</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div class="container">
            <h1>
                {{ $t('biographyPage.artisticPerspective') }}
                <hr>
            </h1>
            <div class="art-philosophy">
                <div class="text-div-philosophy">
                    <p class="multiline"> {{ biographyInfoFiltered.artPerspective }} </p>
                </div>
            </div>
        </div>

        <div class="container">
            <h1>
                {{ $t('biographyPage.artInterpretation') }}
                <hr>
            </h1>
            <div class="art-philosophy">
                <div class="text-div-philosophy">
                    <p class="multiline"> {{ biographyInfoFiltered.artInterPretation }} </p>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useBiographyPageStore } from '../stores/biographyPageStore';

export default{
    data(){
        return{
            store: useBiographyPageStore() 
        }
    },
    computed: {
        biographyInfoFiltered(){
            return this.store.filteredBiographyInfo;
        },
        achievementsInfoFiltered(){
            return this.store.filteredAchievementInfo;
        }
    },
    async created(){
        await this.store.fetchBiographyData();
    }
}
</script>

<style scoped>
#bio-container{
    color: rgb(231, 223, 223);
    width: 100vw;
    height: 100vh;
    
    display: flex;
    flex-direction: column;
    align-items: center;

    background-image: url("../assets/images/80.webp");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: scroll;
}

.container{
    margin-top: 1%;
    margin-bottom: 3%;
    background-color: rgba(37, 37, 35, 0.9);
    border-radius: 1%;
    padding: 1%;
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

h1{
    text-align: center; 
    width: 80%;
    color: rgba(245, 245, 245);
}

#biography{
    margin-top: 1%;
    margin-bottom: 2%;
    padding: 1%;
    width: 90%;
    display: flex;
}

li{
    list-style: square;
}

#photo-div{
    margin-left: auto;
}

#photo-div img{
    width: 400px;
    height: 400px;
    border-radius: 2%;
}

#text-div{
    margin: auto;
    text-align: left;
    width: 50%;
}

#art-philosophy{
    padding: 1%;
    width: 80%;
}

#achievements{
    margin-top: 1%;
    margin-bottom: 3%;
    background-color: rgba(37, 37, 35, 0.9);
    border-radius: 1%;
    padding: 1%;
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

#achievement-child-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

li span{
    margin-right: 4%;
}

.achievement-child{
    width: 110%;
    margin-bottom: 1%;
}

.multiline{
    white-space: pre-line;
}

ul{
    margin: 0;
}

@media (max-width: 768px) {
    #bio-container{
        width: 100vw;
        height: 100vh;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .container, #achievements{
        margin-top: 3%;
        border-radius: 0.5%;
        width: 90%;
    }

    #biography{
        display: flex;
        flex-direction: column;
    }

    #photo-div{
        margin: auto;
        margin-bottom: 5%;
    }

    #photo-div img{
        width: 270px;
        height: 270px;
        
    }

    #text-div{
        text-align: justify;
        width: 100%;
    }

    #achievements{
        margin-bottom: 10%;
    }

    .achievement-child{
        width: 100%;
    }

    .achievement-child h3{
        margin-left: 3%;
    }

    .achievement-child li{
        margin-bottom: 4%;
    }
    
}
</style>